import { DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the tags array
 * @param {string[]} tags - Array of tag strings
 */
export const setTags = (tags) => {
  searchPageStore.setState({ tags })
}

/**
 * Adds a tag to the array
 * @param {string} tag - Tag to add
 */
export const addTag = (tag) => {
  const state = searchPageStore.getState()
  const currentTags = state.tags || []

  if (!currentTags.includes(tag)) {
    searchPageStore.setState({ tags: [...currentTags, tag] })
  }
}

/**
 * Removes a tag from the array
 * @param {string} tag - Tag to remove
 */
export const removeTag = (tag) => {
  const state = searchPageStore.getState()
  const currentTags = state.tags || []

  searchPageStore.setState({
    tags: currentTags.filter((t) => t !== tag),
  })
}

/**
 * Clears all tags filter
 */
export const clearTags = () => {
  searchPageStore.setState({
    tags: DEFAULT_STATE.tags,
  })
}
